// extracted by mini-css-extract-plugin
module.exports = {"root":"az_eSc","labelText":"az_fSc"};